import propTypes from 'prop-types';

const SvgVehicleCarIcon = ({ size, color, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.7 17.875H12.4M1 10.375L4.8 12.25L7.21422 5.10263C7.71254 3.62735 7.9617 2.8897 8.42385 2.34434C8.83195 1.86275 9.35604 1.48998 9.94806 1.2602C10.6185 1 11.4064 1 12.9822 1H27.0178C28.5936 1 29.3815 1 30.0519 1.2602C30.644 1.48998 31.168 1.86275 31.5762 2.34434C32.0383 2.8897 32.2875 3.62735 32.7858 5.10263L35.2 12.25L39 10.375M27.6 17.875H33.3M10.12 12.25H29.88C33.0723 12.25 34.6684 12.25 35.8877 12.8631C36.9603 13.4024 37.8323 14.2629 38.3787 15.3213C39 16.5246 39 18.0997 39 21.25V26.3125C39 27.1837 39 27.6193 38.927 27.9816C38.6271 29.4692 37.4488 30.632 35.9413 30.9279C35.5743 31 35.1328 31 34.25 31H33.3C31.2013 31 29.5 29.3211 29.5 27.25C29.5 26.7322 29.0747 26.3125 28.55 26.3125H11.45C10.9253 26.3125 10.5 26.7322 10.5 27.25C10.5 29.3211 8.79868 31 6.7 31H5.75C4.86716 31 4.42573 31 4.05866 30.9279C2.55123 30.632 1.37286 29.4692 1.07302 27.9816C1 27.6193 1 27.1837 1 26.3125V21.25C1 18.0997 1 16.5246 1.62126 15.3213C2.16774 14.2629 3.03973 13.4024 4.11225 12.8631C5.33155 12.25 6.9277 12.25 10.12 12.25Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

SvgVehicleCarIcon.propTypes = {
  size: propTypes.oneOfType([propTypes.number, propTypes.string]),
  color: propTypes.string,
};

SvgVehicleCarIcon.defaultProps = {
  size: 40,
  color: '#000',
};

export default SvgVehicleCarIcon;

